import { useAuth0 } from "@auth0/auth0-react";

// Mesma saída do menu do Layout: quem cai nas telas públicas de aviso não chega no Layout
export default function useLogoutApp() {
  const { logout } = useAuth0();

  return function logoutApp() {
    localStorage.clear();
    sessionStorage.clear();
    logout({ logoutParams: { returnTo: window.location.origin } });
  };
}
